import { TherapistAction } from 'src/redux/actions/constant';

const {
  THERAPIST_DEFUALT_THERAPIST_REQUEST,
  THERAPIST_DEFAULT_THERAPIST_FAILURE,
  THERAPIST_DEFAULT_THERAPIST_SUCCESS,
  THERAPIST_DEFAULT_THERAPIST_RESET,
} = TherapistAction;

const intialState: object = {
  response: null,
  loading: false,
};

export const defaultThearpistAssignReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case THERAPIST_DEFUALT_THERAPIST_REQUEST: {
      return {
        ...state,
        reponse: null,
        loading: true,
      };
    }
    case THERAPIST_DEFAULT_THERAPIST_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
      };
    }
    case THERAPIST_DEFAULT_THERAPIST_FAILURE: {
      return {
        ...state,
        response: null,
        loading: false,
      };
    }

    case THERAPIST_DEFAULT_THERAPIST_RESET: {
      return intialState;
    }
    default:
      return state;
  }
};
